import http from '../_helpers/http.service';

export const empresaService = {
    traerEmpresas,
    grabar,
    asignarUsuarioAEmpresa
};

function grabar(values) {
    var url = '/api/empresa/grabar';
    return http.post(url, JSON.stringify(values));
}

function asignarUsuarioAEmpresa(values) {
    var url = '/api/empresa/asignarUsuarioAEmpresa';
    return http.post(url, JSON.stringify(values));
}


function traerEmpresas() {
    var url = '/api/empresa/traerEmpresas';
    return http.get(url);
}
